import invSosLogo from '../../../../../assets/img/corporacion-sos-logo.png'

export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 25

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const _drawHeaderDepositTicket = (docPdf, data, posY) => {
        
        // Marco 
        docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50

        // Logo
        const imgWidth = 60;
        const imgHeight = 30;
        docPdf.addImage(invSosLogo, 'PNG', 15, posY-15, imgWidth, imgHeight);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('CORPORACIÓN SOS S.A.', 140, posY, { align: 'center' }); // Centrado
        docPdf.setFontSize(defaultFontSize);

        posY += 5
        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
        docPdf.text('TELEFONO: 2458-1568 EXTENSION 1', 140, posY+5, { align: 'center' });

        posY += 20
        // Fecha
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('FECHA', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_fecha_recibo, 60, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(100, posY, 35, 5, 'F');
        docPdf.rect(100, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('HORA', 110, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_hora_recibo, 140, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ESTADO', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_check, 220, posY+4, { align: 'left' });

        posY += 10
        // Cliente
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CLIENTE', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.datos_cliente, 58, posY+4, { align: 'left' });
        
        // Por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('POR Q', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_quetzal.toLocaleString(), 220, posY+4, { align: 'left' });
        
        posY += 5
        // Concepto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CONCEPTO', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('DEPOSITO POR SOLICITUD DE ARRENDAMIENTO', 58, posY+4, { align: 'left' });
        
        // Fecha de pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('F. PAGO', 185, posY+4, { align: 'left' });

    }

    const _drawIdentifiersDepositTicket = (docPdf, data, posY) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(defaultFontSize);
        docPdf.text(`CONTRATO ${data.contrato_codigo}`, 215, posY);
        docPdf.text(`RECIBO NO. ${data.iddeposit}`, 215, posY+5);

    }

    const _drawInfoDepositTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TIPO', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_tipo, 39, posY+4, { align: 'left' });

        // Monto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONTO', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.deposito_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });

        posY += 5

        // Moneda
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_moneda, 39, posY+4, { align: 'left' });

        // Tipo cambio
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAMBIO', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.deposito_tipo_cambio).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });
        
        posY += 5

        // Total Queztales
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL Q.', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.deposito_quetzal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 39, posY+4, { align: 'left' });

        // Total Dolares
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL $.', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.deposito_dolares).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });
        
        posY += 10

        // Numero de boleta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BOLETA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.boleta_numero || '---', 39, posY+4, { align: 'left' });

        // Referencia ACH
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ACH', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_referencia_ach || '---', 91, posY+4, { align: 'left' });

        posY += 5

        // Banco
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 10, 'F');
        docPdf.rect(20, posY, 108, 10);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO', 21, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.descripcion_banco || '---', 39, posY+4, { align: 'left' });
        // justifyTextBox(docPdf, data.descripcion_banco || '---', 39, posY+4, 80, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })

        posY += 10

        // Cuenta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 10, 'F');
        docPdf.rect(20, posY, 108, 10);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAJA', 21, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.descripcion_caja || '---', 39, posY+4, { align: 'left' });
        // justifyTextBox(docPdf, data.descripcion_caja || '---', 39, posY+4, 80, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
    }

    const _drawObservationsDepositTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY+4, { align: 'left' });
        
        posY += 5
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.deposito_observaciones || '', 181, posY+4, 70, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 35
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.aprobacion_observaciones || '', 181, posY+4, 70, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

    }

    const _drawFooterDepositTicket = (docPdf, data, justifyTextBox, posY) => {
        
        docPdf.line(20, posY, 90, posY);
        docPdf.text('FIRMA AUTORIZADA', 40, posY+7, { align: 'left' });
        docPdf.text('SELLO', 125, posY+4, { align: 'left' });

        // posY += 20
        // docPdf.setFont("helvetica", "normal");
        // const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        // justifyTextBox(docPdf, text, 20, posY, 275, {
    }

    const drawDepositTicket = (pdfManager, data) => {
        
        const { pdfLandscapeDoc, justifyTextBox } = pdfManager

        _drawHeaderDepositTicket(pdfLandscapeDoc, data, 30)
        _drawIdentifiersDepositTicket(pdfLandscapeDoc, data, 30)
        _drawInfoDepositTicket(pdfLandscapeDoc, data, justifyTextBox, 90)
        _drawObservationsDepositTicket(pdfLandscapeDoc, data, justifyTextBox, 90)
        _drawFooterDepositTicket(pdfLandscapeDoc, data, justifyTextBox, 185)

        pdfLandscapeDoc.save(`RECIBO DEPOSITO ${data.contrato_codigo}.pdf`);
    }
    
    return Object.freeze({
        getCurrentDate,
        drawDepositTicket
    })

}